/**
 * /me/profile — Session 3d PR 30.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyProfilePage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-profile", employeeId],
    queryFn: () => session3dApi.getProfile(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.profile.title", "My Profile")}
        subtitle={t("me.profile.subtitle", "Edit self-service-allowed personal info. For other fields, request changes via Khidmat.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.profile.title", "My Profile"),
          window_label: t("me.profile.window", "personal info"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.profile.ask_khidmat", "Help me update my personal info.")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.profile.detail_note",
                "Editable: personal phone · personal email · emergency contact · language preference · profile photo. Read-only with 'Request change via Khidmat' links: salary · position · bank IBAN · contract terms.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
